export default "__VITE_ASSET__d356d963__"